<div class="container">
  <mat-stepper orientation="vertical" [linear]="false" class="mat-elevation-z8" labelPosition="bottom" #clientStepper>
    <ng-template matStepperIcon="number">
      <fa-icon icon="pencil-alt" size="sm"></fa-icon>
    </ng-template>

    <ng-template matStepperIcon="edit">
      <fa-icon icon="pencil-alt" size="sm"></fa-icon>
    </ng-template>

    <ng-template matStepperIcon="done">
      <fa-icon icon="check" size="sm"></fa-icon>
    </ng-template>

    <ng-template matStepperIcon="error">
      <fa-icon icon="exclamation-triangle" size="lg"></fa-icon>
    </ng-template>

    <ng-template matStepperIcon="preview">
      <fa-icon icon="eye" size="sm"></fa-icon>
    </ng-template>

    <mat-step [stepControl]="clientGeneralForm">
      <ng-template matStepLabel>{{ 'labels.inputs.GENERAL' | translate }}</ng-template>

      <LOSx-client-general-step
        [clientTemplate]="clientTemplate"
        (legalFormChangeEvent)="legalFormChange($event)"
      ></LOSx-client-general-step>
    </mat-step>

    <mat-step>
      <ng-template matStepLabel>{{ 'labels.inputs.FAMILY MEMBERS' | translate }}</ng-template>

      <LOSx-client-family-members-step
        #clientFamily
        [clientTemplate]="clientTemplate"
      ></LOSx-client-family-members-step>
    </mat-step>

    @if (clientTemplate.isAddressEnabled) {
      <mat-step>
        <ng-template matStepLabel>{{ 'labels.inputs.ADDRESS' | translate }}</ng-template>
        <LOSx-client-address-step
          #clientAddress
          [clientTemplate]="clientTemplate"
          [clientAddressFieldConfig]="clientAddressFieldConfig"
        >
        </LOSx-client-address-step>
      </mat-step>
    }

    @for (datatable of datatables; track datatable) {
      <mat-step>
        <ng-template matStepLabel>{{ datatable.registeredTableName }}</ng-template>
        <LOSx-client-datatable-step [datatableData]="datatable" #dtclient></LOSx-client-datatable-step>
      </mat-step>
    }

    @if (areFormvalids()) {
      <mat-step completed>
        <ng-template matStepLabel>{{ 'labels.inputs.PREVIEW' | translate }}</ng-template>
        <LOSx-client-preview-step
          [clientTemplate]="clientTemplate"
          [clientAddressFieldConfig]="clientAddressFieldConfig"
          [client]="client"
          (submitEvent)="submit()"
        >
        </LOSx-client-preview-step>
      </mat-step>
    }
  </mat-stepper>
</div>
